const newRenderCartGoal = (cartGoalIndex) => {
        if (document.querySelectorAll(window.tlCartGoalEmbed.ROOT_SELECTOR_ELEMENT).length || window.tlCartGoalEmbed.cartDrawDisplay.selector || window.tlCartGoalEmbed.cartDisplay.selector) {
            let milestonesHTMLInCartDrawer = ``;
            let closestGoal = -1;
            let marginValues = window.tlCartGoalEmbed.getCartGoalsMarginValues();
            window.tlCartGoalEmbed.milestones.map((milestone, index) => {
                if (closestGoal === -1 && milestone.cart_value > window.tlCartGoalEmbed.cartTotal) {
                    closestGoal = index;
                }

                const imgSrc = milestone.reward_type == window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.FREE_GIFT
                    ? window.tlCartGoalEmbed.giftSVG
                    : (milestone.reward_type == window.tlCartGoalEmbed.CART_GOAL_REWARD_TYPE.CART_DISCOUNT
                        ? window.tlCartGoalEmbed.discountSVG : window.tlCartGoalEmbed.freeShippingSVG
                    )

                milestonesHTMLInCartDrawer += `
                    <div class="tl__cart-goal__goal-check-point__drawer" 
                        style="margin-left: ${marginValues[index]}%;
                        z-index: 1;
                        border-color: ${(() => window.tlCartGoalEmbed.cartTotal >= milestone.cart_value ? "var(--tl__cart-goal__filled-bar-color)" : "black")()}"
                    >
                        <p class="tl__cart-goal__goal-check-point-value" 
                            style="color: var(--tl__cart-goal__milestone-label-color); 
                            visibility: ${index === closestGoal ? "visible" : ""}"
                        >
                            ${window.tlCartGoalEmbed.formatMoney(milestone.cart_value * 100, window.tlCartGoalEmbed.currencyFormat, window.tlCartGoalEmbed.currencyDisplay)}
                        </p>
                        <img style = "filter: ${(() => window.tlCartGoalEmbed.cartTotal >= milestone.cart_value 
                            ? "var(--tl__cart-goal__filter-bar-color)" 
                            : "invert(0%) sepia(0%) saturate(3%) hue-rotate(177deg) brightness(100%) contrast(100%)")()}"
                            alt="tl-cart-goal" class="tl__cart-goal__milestone-image" src="${imgSrc}"/>
                        <p class="tl__cart-goal__goal-check-point-title" 
                            style="min-height: 25px; color: var(--tl__cart-goal__milestone-label-color);margin-right:20px;word-wrap: break-word;white-space: normal;text-align: center;min-width: 105px;padding-top: 5px;
                            visibility: ${index === closestGoal ? "visible" : ""}; max-width: 120px;"
                        >${milestone.title}</p>
                    </div>
                `;
            });
            let trademarkHTMLInCartDrawer = window.tlCartGoalEmbed.showTrademark 
                ? `
                <p
                    style="
                        display: block !important;
                        visibility: visible !important;
                        opacity: 1 !important;
                        position: static !important;
                        transform: none !important;
                        clip-path: none !important;
                        overflow: visible !important;
                        width: auto !important;
                        height: auto !important;
                        max-width: none !important;
                        max-height: none !important;
                        background: none !important;
                        color: #000 !important;
                        font-size: 12px !important;
                        text-align: center !important;
                        margin: 0 !important;
                    "
                >
                    Powered by 
                    <a
                        href="https://apps.shopify.com/partners/tek-labs" 
                        target="_blank"
                        style="
                            display: inline !important;
                            visibility: visible !important;
                            opacity: 1 !important;
                            position: static !important;
                            transform: none !important;
                            clip-path: none !important;
                            overflow: visible !important;
                            width: auto !important;
                            height: auto !important;
                            max-width: none !important;
                            max-height: none !important;
                            background: none !important;
                            color: #000 !important;
                            font-size: 12px !important;
                            text-align: center !important;
                            cursor: pointer !important;
                            text-decoration: underline !important;
                        "
                    >
                        Salepify App
                    </a>
                </p>
                ` : "";  
            let cartGoalHTMLInCartDrawer = `
                <div class="tl__cart-goal__container__drawer">
                    <p class="tl__cart-goal__reward-description__drawer">${window.tlCartGoalEmbed.getLeftAmountText(window.tlCartGoalEmbed.milestones[closestGoal])}</p>
                    <div class="tl__cart-goal__goal-container__drawer">
                        <div class="tl__cart-goal__goal-process__drawer" style="display: block; width: ${window.tlCartGoalEmbed.getProcessBarWidth()}%"></div>
                        ${milestonesHTMLInCartDrawer}
                    </div>
                    <hr style="margin: 5px 0px; width: 100%; height: 1px"/>
                    <div class="tl__cart-goal__free-gift-container-${cartGoalIndex}" style="width: 100%; color: #303030">
                        ${window.tlCartGoalEmbed.renderReward(cartGoalIndex)}
                    </div>
                    ${trademarkHTMLInCartDrawer}
                </div>
            `;

            return cartGoalHTMLInCartDrawer;
        }
    }
const intervalId = setInterval(() => {
  if(window.tlCartGoalEmbed){
    clearInterval(intervalId);
    window.tlCartGoalEmbed.renderCartGoal = newRenderCartGoal;  
  }
}, 10);

setTimeout(() => {
  clearInterval(intervalId);
}, 5000);